module.exports = __webpack_public_path__ + "img/Tsehay_logo.a780a9f1.png";